

import './skills.css'
const Skills = () => {

  return (
    <div className="skills">
      <div className="icons">
        <span className="icon react"><i className="fab fa-react fa-9x"></i></span>
        <span className="icon html"><i className="fab fa-html5 fa-9x"></i></span>
        <span className="icon css"><i className="fab fa-css3-alt fa-9x"></i></span>
        <span className="icon js"><i className="fab fa-js-square fa-9x"></i></span>


      </div>
      <div className="exp">

        <div className="head">
          <div className="links">
            <Project name={"LinkBuddy"} 
            description={"A responsive web-app to manage all your school/university meeting links, schedule your classes easily and edit them as per need."}
            link={"https://meetinglink-manager.web.app/login.html"}
            />
            <Project name={"CoinCap Clone"} 
            description={"Cloned Coincap.io landing page displaying diffrent crypto-currencies real-time pricing info. Used React-Js & Redux Saga"}
            link={"https://coincap-clone-v1.web.app/"}
            />
            <Project name={"Mausam"} 
            description={"A single page React web application with stunning UI, which shows weather information of a given location using Openweathermap API."}
            link={"https://mausam-v1.web.app/"}
            />
            <Project name={"Covid Dashboard"} 
            description={"A single page React web application, which shows global covid statistics using re-charts data visualization library"}
            link={"https://global-covid-dashboard.web.app/"}
            />
            <Project name={"Delta-News"} 
            description={"A News website developed using React js and Bootstrap framework. It delivers categorised latest News headlines across the globe through NewsApi."}
            link={"https://delta-news-v1.web.app/"}
            />
            <Project name={"Ecommerce"} 
            description={"A complete E-Commerce website frontend project with Clean , responsive and stunning UI/Ux With a blog page and feedback form for asking queries."}
            link={"https://rounak826.github.io/Ecommerce-site/"}
            />
            
          </div>
        </div>
      </div>


    </div>
  )
}
function Project({name,description,link}) {
  return (
    <div className="link">
      <div>
        <h3>{name}</h3>
        <hr />
      </div>
      
      <p>{description}</p>
      <a href={link}>View Project<span><i className="fas fa-arrow-right"></i></span></a>
    </div>
  )
}
export default Skills